import { makeAutoObservable, observable, toJS } from "mobx";

class AppStore {
  entityId = -1;
  first = -1;
  second = -1;
  entityName = "";
  constructor() {
    makeAutoObservable(this, {
      second: observable,
      first: observable,
      entityId: observable,
      entityName: observable,
    });
  }

  setFirst(first) {
    this.first = first;
  }
  setSecond(second) {
    this.second = second;
  }

  setEntityId(entityId) {
    this.entityId = entityId;
  }

  setEntityName(name) {
    this.entityName = name;
  }
}

export default new AppStore();
